import { useCallback } from 'react';
import { ValidationTabsEnum } from '../../../../types/validation';
import useLegendStore from '../../../../store/legendStore';
import { useAnalyticsSelectionStore } from '../../../../store/analyticsSelectionStore';
import {
  EVENT_VALIDATION_INSITU_SELECTED,
  EVENT_VALIDATION_SATELLITE_SELECTED,
  trackUpdate,
} from '../../../../utils/matomoEvents';
import { DEFAULT_ANALYTICS } from '../../../../types/analytics';
import { IMarker } from '../../../../types/marker';

export function useValidationTabs(activePoint?: IMarker, datasetId?: string) {
  const markerId = activePoint?.id ?? '';
  const activeValidationTab = useAnalyticsSelectionStore(
    (state) => state.getMarkerSelection(markerId).activeValidationTab
  );
  const setActiveValidationTab = useAnalyticsSelectionStore(
    (state) => state.setActiveValidationTab
  );
  const setShowInSituPoints = useLegendStore(
    (state) => state.setShowInSituPoints
  );

  const handleChangeTab = useCallback(
    (key: ValidationTabsEnum) => {
      if (activePoint?.coordinates?.length && datasetId) {
        const eventType =
          key === ValidationTabsEnum.INSITU_TAB
            ? EVENT_VALIDATION_INSITU_SELECTED
            : EVENT_VALIDATION_SATELLITE_SELECTED;
        trackUpdate(
          eventType,
          activePoint.coordinates,
          datasetId,
          key === ValidationTabsEnum.INSITU_TAB ? DEFAULT_ANALYTICS : ''
        );
      }
      if (key === ValidationTabsEnum.INSITU_TAB) {
        setShowInSituPoints(true);
      }
      setActiveValidationTab(markerId, key);
    },
    [
      activePoint?.coordinates,
      datasetId,
      setShowInSituPoints,
      markerId,
      setActiveValidationTab,
    ]
  );

  return { activeValidationTab, handleChangeTab };
}
